import React from 'react';
import { trackCheckoutStart } from '../lib/metaPixel';
import { PRICE } from '../data/content';
import { SecurePaymentNote } from './SecurePaymentNote';

/** Le seul checkout vers lequel mène le bouton de l’offre. */
export const CHECKOUT_URL = 'https://barber-instructor-fr.impultienda.ar/checkout';
export const CURRENCY_NOTE = 'Paiement sécurisé · Traité dans votre devise locale';

/** Ancre du bloc d’offre — le seul bouton qui ouvre le checkout. */
export const OFFER_ANCHOR = '#offer-cta';
interface CtaButtonProps {
  label: string;
  /** 'checkout' ouvre le checkout ; 'offer' fait défiler jusqu’au bloc d’offre. */
  action?: 'checkout' | 'offer';
  className?: string;
}
export function CtaButton({
  label,
  action = 'offer',
  className = ''
}: CtaButtonProps) {
  const isCheckout = action === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : OFFER_ANCHOR} onClick={isCheckout ? trackCheckoutStart : undefined} className={`group inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-[14px] bg-brand-cta px-6 py-[18px] font-body text-[14px] font-bold uppercase tracking-[0.06em] text-brand-cta-text shadow-[0_5px_0_0_#2E3F1A,0_18px_34px_-14px_rgba(76,103,43,0.7)] transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-brand-cta-dark active:translate-y-[3px] active:shadow-[0_2px_0_0_#2E3F1A] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-cta focus-visible:ring-offset-2 focus-visible:ring-offset-brand-ivory sm:px-8 sm:text-[15px] ${className}`} data-id="element-1" data-mp="19c35up7ca4wc">
      <span data-id="element-2" data-mp="3svitlbvjtnhs">{label}</span>
      <span aria-hidden="true" className="text-base font-normal transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-3" data-mp="1j7rkxcyp8cx">
        →
      </span>
    </a>;
}
interface CtaBlockProps {
  label: string;
  /** Bloc d’offre : affiche le prix et c’est le seul qui ouvre le checkout. */
  showPrice?: boolean;
  tone?: 'light' | 'dark';
  className?: string;
}
export function CtaBlock({
  label,
  showPrice = false,
  tone = 'light',
  className = ''
}: CtaBlockProps) {
  const muted = tone === 'dark' ? 'text-brand-ivory/70' : 'text-brand-charcoal/55';
  return <div id={showPrice ? 'offer-cta' : undefined} className={`flex scroll-mt-24 flex-col items-center text-center ${className}`} data-id="element-4" data-mp="hw3o73sodm1">
      {showPrice ? <>
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold" data-id="element-5" data-mp="3ruh1wqy0rw51">
            Paiement unique
          </p>
          <p className="mt-2 font-body text-[3rem] font-bold leading-none tracking-[-0.01em] text-brand-charcoal" data-id="element-6" data-mp="4k990uemq9ia">
            {PRICE}
          </p>
        </> : <p className={`font-body text-[11px] uppercase tracking-[0.14em] ${muted}`} data-id="element-7" data-mp="ehnnwpkwmq8h">{CURRENCY_NOTE}</p>}
      <CtaButton label={label} action={showPrice ? 'checkout' : 'offer'} className="mt-4 w-full sm:w-auto sm:min-w-[420px]" data-id="element-8" data-mp="2l7tso498kqm8" />
      {showPrice && <SecurePaymentNote className="mt-5" data-id="element-9" data-mp="2gb3ityo0yr99" />}
    </div>;
}